import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelS, LabelL } from '@sorare/core/src/atoms/typography';

import { Cards } from '@sorare/core/src/assets/icons/Cards.tsx';
import { Shirt } from '@sorare/core/src/atoms/icons/shirts/Shirt.tsx';
import { useSetHasMultipleSkins } from '#src/hooks/my-cards/useSetHasMultipleSkins.ts';
import type { CollectionSlotsStats_userCardCollection } from './__generated__/index.graphql.ts';

type Props = {
  cardSetSlug?: string | null;
  userCardCollection?: CollectionSlotsStats_userCardCollection | null;
};

export const CollectionSlotsStats = ({
  cardSetSlug,
  userCardCollection,
}: Props) => {
  const displayPlayersCount = useSetHasMultipleSkins(cardSetSlug);

  const {
    slotsCount,
    fulfilledSlotsCount,
    ownedPlayersCount,
    totalPlayersCount,
  } = userCardCollection || {};

  return (
    <Vertical gap={0.5}>
      {!!displayPlayersCount && (
        <Horizontal gap={0.5}>
          <span>
            <LabelL bold as="span">
              {ownedPlayersCount}
            </LabelL>
            <LabelS as="span" color="var(--c-nd-700)">
              /{totalPlayersCount}
            </LabelS>
          </span>
          <Shirt size={1.5} />
        </Horizontal>
      )}
      <Horizontal gap={0.5}>
        <span>
          <LabelL bold as="span">
            {fulfilledSlotsCount}
          </LabelL>
          <LabelS as="span" color="var(--c-nd-700)">
            /{slotsCount}
          </LabelS>
        </span>
        <Cards size={1.5} />
      </Horizontal>
    </Vertical>
  );
};

CollectionSlotsStats.fragments = {
  userCardCollection: gql`
    fragment CollectionSlotsStats_userCardCollection on UserCardCollection {
      id
      slotsCount
      fulfilledSlotsCount
      ownedPlayersCount
      totalPlayersCount
    }
  ` as TypedDocumentNode<CollectionSlotsStats_userCardCollection>,
};
